import { getPermissionsWithParentScopes } from '@/mixins/getPermissionsWithParentScopes';
import { usePage } from '@inertiajs/vue3';

type RequiredPermissions = string | string[] | null | undefined;

export function hasAnyPermission(requiredPermissions: RequiredPermissions): boolean {
    // Exit early if no permissions are required
    if (!requiredPermissions || (Array.isArray(requiredPermissions) && requiredPermissions.length === 0)) {
        return false;
    }

    const $page = usePage();
    const permissions = (Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions]).filter((n): n is string => Boolean(n));

    // Current permissions of the user
    const assignedPermissions: string[] = $page.props.auth.can;

    // Add parent scopes to allow access if a user has broader permissions.
    // Example:
    // - Required permission: 'asset.read'
    // A user with the broader permission `asset.*` also has access
    const expanded = permissions.flatMap((permission) => getPermissionsWithParentScopes(permission));

    return expanded.some((permission) => assignedPermissions.includes(permission));
}

export default {
    methods: {
        hasAnyPermission,
    },
};
